const urlPattern = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;

export const validatePublications = (values) => {
  return values.map((pub, idx) => {
    if (!pub.title) {
      return { idx, error: "Title is required", name: "title" };
    }

    if (isNaN(pub.no_of_citations)) {
      return {
        idx,
        error: "No. of citations must be a number",
        name: "no_of_citations",
      };
    }
    
    const link = pub.url || pub.link;
 
    if (link) {
      if (!link.startsWith("https://")) {
        return { idx, error: "URL must start with https://", name: "url" };
      }
      // check if url is valid
      if (!urlPattern.test(link)) {
          return { idx, error: "URL is invalid", name: "url" };
      }  
    }
    
    return null;
  }).filter(error => error !== null); // Filter out null values
};
